import { Builder } from "@builder.io/react";
import { allowedFileTypes, allowedFileTypesVideo, commonInputs, registerMenuGroups } from "./helper";
import { Hero1, Hero2, Hero3, Hero4, Hero5, Hero6, Hero7, Hero8, Hero9, Hero10, Hero11, Hero12, Hero13, Hero14, Hero15, Hero16, Hero17, Hero18, Hero19, Hero20, Hero21, Hero22 } from "../components/Hero";

const heroGroups = [
  {
    name: "Hero Components",
    items: [
      { name: "Hero 1" },
      { name: "Hero 2" },
      { name: "Hero 3" },
      { name: "Hero 4" },
      { name: "Hero 5" },
      { name: "Hero 6" },
      { name: "Hero 7" },
      { name: "Hero 8" },
      { name: "Hero 9" },
      { name: "Hero 10" },
      { name: "Hero 11" },
      { name: "Hero 12" },
      { name: "Hero 13" },
      { name: "Hero 14" },
      { name: "Hero 15" },
      { name: "Hero 16" },
      { name: "Hero 17" },  
      { name: "Hero 18" },
      { name: "Hero 19" },
      { name: "Hero 20" },
      { name: "Hero 21" },
      { name: "Hero 22" }
    ]
  }
];

export const registerHeroComponents = () => {
  registerMenuGroups(heroGroups);

  // Hero Components
  Builder.registerComponent(Hero1, {
    name: "Hero 1",
    noWrap: true,  
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "content",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "outline",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
        ],
      },
      {
        name: "images",
        type: "list",
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero2, {
    name: "Hero 2",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          image: "/placeholder.svg",
          imageAltText: "Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Button Text",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
        ],
      },
      {
        name: "hasStats",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "statsAtBottom",
        type: "boolean",
        defaultValue: false,
        showIf: `options.get('hasStats') === true`,
      },
      {
        name: "stats",
        type: "list",
        showIf: `options.get('hasStats') === true`,
        subFields: [
          {
            name: "value",
            type: "string",
          },
          {
            name: "label",
            type: "string", 
          },
        ],
      },
    ],
  });

  Builder.registerComponent(Hero3, {
    name: "Hero 3",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          backgroundImage: "/placeholder.svg",
          backgroundImageAltText: "Background Image Alt Text",
          overlayImage1: "/placeholder.svg",
          overlayImage1AltText: "Overlay Image 1 Alt Text",
          overlayImage2: "/placeholder.svg",
          overlayImage2AltText: "Overlay Image 2 Alt Text",
          overlayImage3: "/placeholder.svg",
          overlayImage3AltText: "Overlay Image 3 Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          ...commonInputs.imageInput({
            name: "backgroundImage",
            includeAltText: true,
          }),
          ...commonInputs.imageInput({
            name: "overlayImage1",
            includeAltText: true,
            friendlyName: "Overlay image left top",
          }),
          ...commonInputs.imageInput({
            name: "overlayImage2",
            includeAltText: true,
            friendlyName: "Overlay image left bottom",
          }),
          ...commonInputs.imageInput({
            name: "overlayImage3",
            includeAltText: true,
            friendlyName: "Overlay image right top",
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero4, {
    name: "Hero 4",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          leftImage: "/placeholder.svg",
          leftImageAltText: "Left Image Alt Text",
          rightTopImage: "/placeholder.svg",
          rightTopImageAltText: "Right Top Image Alt Text",
          rightBottomImage: "/placeholder.svg",
          rightBottomImageAltText: "Right Bottom Image Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          ...commonInputs.imageInput({
            name: "leftImage",
            includeAltText: true,
            friendlyName: "Left image",
          }),
          ...commonInputs.imageInput({
            name: "rightTopImage",
            includeAltText: true,
            friendlyName: "Right top image",
          }),
          ...commonInputs.imageInput({
            name: "rightBottomImage",
            includeAltText: true,
            friendlyName: "Right bottom image",
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero5, {
    name: "Hero 5",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
      {
        name: "hasFeaturedItems",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "featuredItemsWithDarkIconBg",
        type: "boolean",
        defaultValue: false,
        showIf: `options.get('hasFeaturedItems') === true`,
      },
      {
        name: "featuredItems",
        type: "list",
        showIf: `options.get('hasFeaturedItems') === true`,
        defaultValue: [
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeIcon: true,
            includeTitle: true,
            includeContent: true,
          }),
        ],
      }
    ],
  });

  Builder.registerComponent(Hero6, {
    name: "Hero 6",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "outline",
          hasStatus: true,
          status: {
            statusValue1: "100",
            statusLabel1: "Status 1 Label",
            statusValue2: "200",
            statusLabel2: "Status 2 Label",
          },
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          {
            name: "hasStatus",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "status",
            type: "object",
            showIf: `options.get('hasStatus') === true`,
            subFields: [
              {
                name: "statusValue1",
                type: "string",
              },
              {
                name: "statusLabel1",
                type: "richText",
              },
              {
                name: "statusValue2",
                type: "string",
              },
              {
                name: "statusLabel2",
                type: "richText",
              },
            ],
          },
        ],
      },
      {
        name: "features",
        type: "list",
        defaultValue: [
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
          {
            icon: "currency_exchange",
            title: "Featured Item Title",
            content: "Content",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeIcon: true,
            includeTitle: true,
            includeContent: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero7, {
    name: "Hero 7",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          // featuredItems: [
          //   {
          //     image: "/placeholder.svg",
          //     imageAltText: "Image Alt Text",
          //     badge: "Badge",
          //     title: "Featured Item Title",
          //     content: "Content",
          //     link: "/",
          //   },
          //   {
          //     image: "/placeholder.svg",
          //     imageAltText: "Image Alt Text",
          //     badge: "Badge",
          //     title: "Featured Item Title",
          //     content: "Content",
          //     link: "/",
          //   },
          //   {
          //     image: "/placeholder.svg",
          //     imageAltText: "Image Alt Text",
          //     badge: "Badge",
          //     title: "Featured Item Title",
          //     content: "Content",
          //     link: "/",
          //   },
          //   {
          //     image: "/placeholder.svg",
          //     imageAltText: "Image Alt Text",
          //     badge: "Badge",
          //     title: "Featured Item Title",
          //     content: "Content",
          //     link: "/",
          //   },
          //   {
          //     image: "/placeholder.svg",
          //     imageAltText: "Image Alt Text",
          //     badge: "Badge",
          //     title: "Featured Item Title",
          //     content: "Content",
          //     link: "/",
          //   },
          // ],
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
          }),
          // {
          //   name: "featuredItems",
          //   type: "list",
          //   subFields: [
          //     ...commonInputs.imageInput({
          //       name: "image",
          //       includeAltText: true,
          //     }),
          //     ...commonInputs.contentInputs({
          //       includeBadge: true,
          //       includeTitle: true,
          //       includeContent: true,
          //       includeLink: true,
          //     }),
          //   ],
          // },
        ],
      },
    ],
  });

  Builder.registerComponent(Hero8, {
    name: "Hero 8",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          hasImage: false,
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          {
            name: "hasImage",
            type: "boolean",
            defaultValue: false,
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
            showIf: `options.get('hasImage') === true`,
          }),
          {
            name: "hasCodeBox",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "codeBox",
            type: "longText",
            showIf: `options.get('hasCodeBox') === true`,
          },
        ],
      },
    ],
  });

  Builder.registerComponent(Hero9, {
    name: "Hero 9",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero10, {
    name: "Hero 10",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          image1: "/placeholder.svg",
          image1AltText: "Image 1 Alt Text",
          image2: "/placeholder.svg",
          image2AltText: "Image 2 Alt Text",
          image3: "/placeholder.svg",
          image3AltText: "Image 3 Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          ...commonInputs.imageInput({
            name: "image1",
            includeAltText: true,
          }),
          ...commonInputs.imageInput({
            name: "image2",
            includeAltText: true,
          }),
          ...commonInputs.imageInput({
            name: "image3",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero11, {
    name: "Hero 11",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
        ],
      },
    ],
  }); 

  Builder.registerComponent(Hero12, {
    name: "Hero 12",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero13, {
    name: "Hero 13",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          leftTopImage: "/placeholder.svg",
          leftTopImageAltText: "Left Top Image Alt Text",
          leftBottomImage: "/placeholder.svg",
          leftBottomImageAltText: "Left Bottom Image Alt Text",
          rightTopImage: "/placeholder.svg",
          rightTopImageAltText: "Right Top Image Alt Text",
          rightBottomImage: "/placeholder.svg",
          rightBottomImageAltText: "Right Bottom Image Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          ...commonInputs.imageInput({
            name: "leftTopImage",
            includeAltText: true,
          }),
          ...commonInputs.imageInput({
            name: "leftBottomImage",
            includeAltText: true,
          }),
          ...commonInputs.imageInput({
            name: "rightTopImage",
            includeAltText: true,
          }),
          ...commonInputs.imageInput({
            name: "rightBottomImage",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero14, {
    name: "Hero 14",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasButton: true,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
          featuredItem: "video",
          video: "/",
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
          featuredImage1: "/placeholder.svg",
          featuredImage1AltText: "Featured Image 1 Alt Text",
          featuredImage2: "/placeholder.svg",
          featuredImage2AltText: "Featured Image 2 Alt Text",
          status: [
            {
              value: "100",
              label: "Status 1 Label",
            },
            {
              value: "200",
              label: "Status 2 Label",
            },
            {
              value: "300",
              label: "Status 3 Label",
            },
          ],
          hasFeaturedItems: true,
          featuredItems: [
            {
              icon: "currency_exchange",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              content: "Content",
            },
          ],
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          {
            name: "hasStatus",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "status",
            type: "list",
            showIf: `options.get('hasStatus') === true`,
            subFields: [
              {
                name: "value",
                type: "string",
              },
              {
                name: "label",
                type: "richText",
              },
            ]
          },
          {
            name: "hasFeaturedItems",
            type: "boolean",
          },
          {
            name: "featuredItems",
            type: "list",
            showIf: `options.get('hasFeaturedItems') === true`,
            subFields: [
              {
                name: "icon",
                type: "string",
              },
              {
                name: "content",
                type: "richText",
              },
            ],
          },
          {
            name: "hasButton",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "featuredItem",
            type: "string",
            enum: ["video", "image"],
            defaultValue: "image",
          },
          {
            name: "video",
            type: "url",
            showIf: `options.get('featuredItem') === 'video'`,
            defaultValue: "/",
          },
          {
            name: "loopVideo",
            type: "file",
            allowedFileTypes: allowedFileTypesVideo,
            showIf: `options.get('featuredItem') === 'video'`,
            helperText: "Loop video has higher priority than the image below. and will fallback to image below if error occurs.",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
            showIf: `options.get('featuredItem') === 'image' || options.get('featuredItem') === 'video'`,
          }),
          ...commonInputs.imageInput({
            name: "featuredImage1",
            includeAltText: true,
          }),
          ...commonInputs.imageInput({
            name: "featuredImage2",
            includeAltText: true,
          }),
          
        ],
      },
    ],
  }); 

  Builder.registerComponent(Hero15, {
    name: "Hero 15",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
        ],
      },
    ],
  }); 

  Builder.registerComponent(Hero16, {
    name: "Hero 16",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
          hasMediaBlocks: true,
          mediaBlocks: {
            image: "/placeholder.svg",
            imageAltText: "Media Block Image Alt Text",
            label: "Media Block Label",
            content: "Content",
          },
          hasFeatureBlocks: true,
          featureBlocksTitle: "Feature Blocks Title",
          featureBlocksContent: "Content",
          featureBlocks: [
            {
              icon: "currency_exchange",
              title: "Feature Block Title",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              title: "Feature Block Title",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              title: "Feature Block Title",
              content: "Content",
            }
          ]
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          {
            name: "hasMediaBlocks",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "mediaBlocks",
            type: "object",
            showIf: `options.get('hasMediaBlocks') === true`,
            subFields: [
              ...commonInputs.imageInput({
                name: "image",
                includeAltText: true,
              }),
              {
                name: "label",
                type: "string",
              },
              {
                name: "content",
                type: "richText",
              }                
            ]
          },
          {
            name: "hasFeatureBlocks",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "featureBlocksTitle",
            type: "string",
            showIf: `options.get('hasFeatureBlocks') === true`,
            defaultValue: "Feature Blocks Title",
          },
          {
            name: "featureBlocksContent",
            type: "richText",
            showIf: `options.get('hasFeatureBlocks') === true`,
            defaultValue: "Content",
          },
          {
            name: "featureBlocks",
            type: "list",
            showIf: `options.get('hasFeatureBlocks') === true`,
            subFields: [
              ...commonInputs.contentInputs({
                includeIcon: true,
                includeTitle: true,
                includeContent: true,
              }),
            ]
          }
        ],
      },
    ],
  }); 

  Builder.registerComponent(Hero17, {
    name: "Hero 17",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          showLastUpdatedDate: false,
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          {
            name: "showLastUpdatedDate",
            type: "boolean",
            defaultValue: false,
          },
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero18, {
    name: "Hero 18",
    noWrap: true,
    hideFromInsertMenu: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasButton: true,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
          featuredItem: "video",
          video: "/",
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
          featuredImage1: "/placeholder.svg",
          featuredImage1AltText: "Featured Image 1 Alt Text",
          status: [
            {
              value: "100",
              label: "Status 1 Label",
            },
            {
              value: "200",
              label: "Status 2 Label",
            },
            {
              value: "300",
              label: "Status 3 Label",
            },
          ],
          hasFeaturedItems: true,
          featuredItems: [
            {
              icon: "currency_exchange",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              content: "Content",
            },
          ],
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          {
            name: "hasStatus",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "status",
            type: "list",
            showIf: `options.get('hasStatus') === true`,
            subFields: [
              {
                name: "value",
                type: "string",
              },
              {
                name: "label",
                type: "richText",
              },
            ]
          },
          {
            name: "hasFeaturedItems",
            type: "boolean",
          },
          {
            name: "featuredItems",
            type: "list",
            showIf: `options.get('hasFeaturedItems') === true`,
            subFields: [
              {
                name: "icon",
                type: "string",
              },
              {
                name: "content",
                type: "richText",
              },
            ],
          },
          {
            name: "hasButton",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "featuredItem",
            type: "string",
            enum: ["video", "image"],
            defaultValue: "image",
          },
          {
            name: "video",
            type: "url",
            showIf: `options.get('featuredItem') === 'video'`,
            defaultValue: "/",
          },
          {
            name: "loopVideo",
            type: "file",
            allowedFileTypes: allowedFileTypesVideo,
            showIf: `options.get('featuredItem') === 'video'`,
            helperText: "Loop video has higher priority than the image below. and will fallback to image below if error occurs.",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
            showIf: `options.get('featuredItem') === 'image' || options.get('featuredItem') === 'video'`,
          }),
          ...commonInputs.imageInput({
            name: "featuredImage1",
            includeAltText: true,
          }),
        ],
      },
    ],
  }); 

  Builder.registerComponent(Hero19, {
    name: "Hero 19",
    noWrap: true,
    hideFromInsertMenu: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasButton: true,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
          featuredItem: "video",
          video: "/",
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
          featuredImage1: "/placeholder.svg",
          featuredImage1AltText: "Featured Image 1 Alt Text",
          status: [
            {
              value: "100",
              label: "Status 1 Label",
            },
            {
              value: "200",
              label: "Status 2 Label",
            },
            {
              value: "300",
              label: "Status 3 Label",
            },
          ],
          hasFeaturedItems: true,
          featuredItems: [
            {
              icon: "currency_exchange",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              content: "Content",
            },
          ],
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          {
            name: "hasStatus",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "status",
            type: "list",
            showIf: `options.get('hasStatus') === true`,
            subFields: [
              {
                name: "value",
                type: "string",
              },
              {
                name: "label",
                type: "richText",
              },
            ]
          },
          {
            name: "hasFeaturedItems",
            type: "boolean",
          },
          {
            name: "featuredItems",
            type: "list",
            showIf: `options.get('hasFeaturedItems') === true`,
            subFields: [
              {
                name: "icon",
                type: "string",
              },
              {
                name: "content",
                type: "richText",
              },
            ],
          },
          {
            name: "hasButton",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "featuredItem",
            type: "string",
            enum: ["video", "image"],
            defaultValue: "image",
          },
          {
            name: "video",
            type: "url",
            showIf: `options.get('featuredItem') === 'video'`,
            defaultValue: "/",
          },
          {
            name: "loopVideo",
            type: "file",
            allowedFileTypes: allowedFileTypesVideo,
            showIf: `options.get('featuredItem') === 'video'`,
            helperText: "Loop video has higher priority than the image below. and will fallback to image below if error occurs.",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
            showIf: `options.get('featuredItem') === 'image' || options.get('featuredItem') === 'video'`,
          }),
          ...commonInputs.imageInput({
            name: "featuredImage1",
            includeAltText: true,
          }),
        ],
      },
    ],
  }); 

  Builder.registerComponent(Hero20, {
    name: "Hero 20",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          hasAnimatedText: true,
          animatedText: [
            {
              text: "Animated Text 1",
            },
            {
              text: "Animated Text 2",
            },
            {
              text: "Animated Text 3",
            },
          ],
          hasButton: true,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
          hasImage: true,
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
          hasStats: true,
          stats: [
            {
              value: "100",
              label: "Status 1 Label",
            },
            {
              value: "200",
              label: "Status 2 Label",
            },
            {
              value: "300",
              label: "Status 3 Label",
            },
          ],
          hasFeaturedItems: true,
          featuredItems: [
            {
              icon: "currency_exchange",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              content: "Content",
            },
            {
              icon: "currency_exchange",
              content: "Content",
            },
          ],
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          {
            name: "hasAnimatedText",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "animatedText",
            type: "list",
            showIf: `options.get('hasAnimatedText') === true`,
            subFields: [
              {
                name: "text",
                type: "string",
              },
            ],
          },
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          {
            name: "hasStats",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "stats",
            type: "list",
            showIf: `options.get('hasStats') === true`,
            subFields: [
              {
                name: "value",
                type: "string",
              },
              {
                name: "label",
                type: "richText",
              },
            ]
          },
          {
            name: "hasFeaturedItems",
            type: "boolean",
          },
          {
            name: "featuredItems",
            type: "list",
            showIf: `options.get('hasFeaturedItems') === true`,
            subFields: [
              {
                name: "icon",
                type: "string",
              },
              {
                name: "content",
                type: "richText",
              },
            ],
          },
          {
            name: "hasImage",
            type: "boolean",
            defaultValue: false,
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
            showIf: `options.get('hasImage') === true`,
          }),
        ],
      },
    ],
  }); 

  Builder.registerComponent(Hero21, {
    name: "Hero 21",
    noWrap: true,
    inputs: [
      ...Object.values(commonInputs.baseHero),
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          microCopy: "Microcopy",
          image: "/placeholder.svg",
          imageAltText: "Image Alt Text",
          hasButton: false,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          secondaryButton: false,
          secondaryButtonText: "Secondary Button Text",
          secondaryButtonLink: "/",
          secondaryButtonStyle: "primary",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
          {
            name: "video",
            type: "url",
            defaultValue: "/",
          },
          {
            name: "videoThumbnail",
            type: "file",
            allowedFileTypes: allowedFileTypes,  // all image file types
          },
          {
            name: "videoThumbnailAltText",
            type: "string",
            defaultValue: "Video Thumbnail Alt Text",
          },
          {
            name: "videoHelperText",
            type: "string",
            defaultValue: "Helper text for the video.",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Hero22, {
    name: "Hero 22",
    noWrap: true,
    inputs: [
      {
        name: "parallaxScroll",
        friendlyName: "Parallax scroll (content slides over)",
        type: "boolean",
        defaultValue: true,
        helperText: "When on, the hero sticks to the top and sections below slide over it as the user scrolls.",
      },
      {
        name: "contents",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button Text",
          buttonLink: "/",
          buttonStyle: "primary",
          mediaType: "image",
          image: "/placeholder.svg",
          imageAltText: "Hero Image",
        },
        subFields: [
          {
            name: "mediaType",
            type: "string",
            enum: ["image", "video", "none"],
            defaultValue: "image",
            helperText: "Choose whether to display a static image, a looping background video, or no media (text content only).",
          },
          {
            name: "loopVideo",
            type: "file",
            allowedFileTypes: allowedFileTypesVideo,
            showIf: `options.get('mediaType') === 'video'`,
            helperText: "Looping muted background video (mp4/webm recommended). Falls back to image on error.",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
            helperText: "Used as the static image, or as a fallback if the video fails to load.",
            showIf: `options.get('mediaType') !== 'none'`,
          }),
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({ excludeMicroCopy: true }),
        ],
      },
      {
        name: "contentPosition",
        friendlyName: "Content position",
        type: "string",
        enum: [
          "top-left",    "top-center",    "top-right",
          "middle-left", "middle-center", "middle-right",
          "bottom-left", "bottom-center", "bottom-right",
        ],
        defaultValue: "bottom-center",
        helperText: "Position of the text content over the media.",
      },
      {
        name: "contentInDark",
        friendlyName: "Dark content text",
        type: "boolean",
        defaultValue: false,
        helperText: "When on, content text (title, description, badge) is displayed in dark colour — use for no-media or light-background heroes.",
      },
      {
        name: "overlayOpacity",
        type: "string",
        enum: ["none", "light", "medium", "dark", "solid-white"],
        defaultValue: "medium",
        helperText: "Dark tint overlay on the media to improve text readability.",
      },
      {
        name: "minHeight",
        type: "number",
        helperText: "Minimum height (px). Leave empty for no minimum.",
      },
    ],
  });
};